// The month and season the user is working on, shared by all data pages so
// switching from (say) Lab to Chemical keeps the same period selected.
// Kept per browser tab and cleared on logout.
const KEY = "selectedPeriod";

/** Returns { month, year }: month "1".."12" (as a string), year like "2026-27". */
export const getRememberedPeriod = () => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY));
    return { month: saved?.month || "", year: saved?.year || "" };
  } catch {
    return { month: "", year: "" };
  }
};

export const rememberPeriod = (month, year) => {
  sessionStorage.setItem(
    KEY,
    JSON.stringify({ month: month ? String(month) : "", year: year || "" })
  );
};

export const clearRememberedPeriod = () => {
  sessionStorage.removeItem(KEY);
};
